import * as React from "react"
import {Link} from "gatsby"
import "./reviews.css"

const Reviews = () => {
    return (
        <section className="wrapper bg-light">
            <div className="container py-8 py-md-10">
                <div className="row gx-xl-12 gy-10">
                    <div className="col-xl-4 text-center text-lg-start">
                        <h2
                            data-sal="slide-right"
                            data-sal-delay="100"
                            data-sal-easing="easeInExpo"
                            className="display-1 mt-10 mb-3"
                        >
                            Testimonials
                        </h2>
                        <p
                            data-sal="slide-right"
                            data-sal-delay="200"
                            data-sal-easing="easeInExpo"
                            className="lead fs-lg mb-6"
                        >
                            Customer satisfaction is our major goal. See what our customers
                            are saying about our product.
                        </p>
                        <Link
                            data-sal="slide-right"
                            data-sal-delay="300"
                            data-sal-easing="easeInExpo"
                            to="/testimonials"
                            className="btn btn-orange btn-lg rounded-pill">
                            All Testimonials
                        </Link>
                    </div>
                    <div className="col-xl-8">
                        <div className="grid grid-view">
                            <div className="row gx-md-8 gy-10 gy-md-13">
                                <div
                                    data-sal="slide-left"
                                    data-sal-delay="100"
                                    data-sal-easing="easeInExpo"
                                    className="item col-xl-6 col-xs-10 d-flex align-items-stretch"
                                >
                                    <div className="item-inner d-flex align-items-stretch">
                                        <div className="card d-flex align-items-stretch">
                                            <div className="card-body">
                                                <blockquote className="icon mb-0">
                                                    <p>
                                                        “The standard of their service and products is very high and
                                                        they
                                                        always strive to make improvements to
                                                        accommodate our needs and improve the quality and presentation
                                                        of our finished products.”
                                                    </p>
                                                    <div className="blockquote-details">
                                                        <div className="">
                                                            <h5 className="mb-1">
                                                                Graham Elsey
                                                            </h5>
                                                            <p className="mb-0">
                                                                Growtivation
                                                            </p>
                                                        </div>
                                                    </div>
                                                </blockquote>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    data-sal="slide-left"
                                    data-sal-delay="100"
                                    data-sal-easing="easeInExpo"
                                    className="item col-xl-6 col-xs-10 d-flex align-items-stretch"
                                >
                                    <div className="item-inner d-flex align-items-stretch">
                                        <div className="card d-flex align-items-stretch">
                                            <div className="card-body">
                                                <blockquote className="icon mb-0">
                                                    <p>
                                                        “Centuary has been doing business with Texbond since 2008.
                                                        The prices are competitive and deliveries are always on time.
                                                        Any technical issues raised, these are sorted out on a war
                                                        footing basis. Texbond team is very supportive.”
                                                    </p>
                                                    <div className="blockquote-details">
                                                        <div className="">
                                                            <h5 className="mb-1">
                                                                Satya Subbarao
                                                            </h5>
                                                            <p className="mb-0">
                                                                Century Mattresses
                                                            </p>
                                                        </div>
                                                    </div>
                                                </blockquote>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Reviews